import React, { useState, useEffect } from 'react';
import { useObservable } from 'react-use-observable';

import { Input, Modal } from 'antd';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import { Header } from './Header';
import { List } from './List';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  selectedQuantity: number;
  selectedAffiliates: IAffiliateOption[];
  handleUncheckAll: () => void;
}

export const Dialog = ({ isOpen, selectedAffiliates, selectedQuantity, onClose, handleUncheckAll }: IProps) => {
  const [affiliates] = useObservable(() => selectAffiliateService.getAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const [affiliateFilter, setAffiliateFilter] = useState('');

  useEffect(() => {
    return () => setAffiliateFilter('');
  }, []);

  const handleClose = () => {
    setAffiliateFilter('');
    onClose();
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAffiliateFilter(e.target.value);
  };

  const filteredAffiliates = affiliateFilter
    ? (affiliates || []).filter(affiliate => {
        const lowerCaseName = affiliate.name.toLowerCase();
        const lowerCaseEmail = affiliate.email.toLowerCase();
        const lowerCaseFilter = affiliateFilter.toLowerCase();

        return lowerCaseName.includes(lowerCaseFilter) || lowerCaseEmail.includes(lowerCaseFilter);
      })
    : affiliates;

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      onOk={handleClose}
      width='90vw'
      title={isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}
      cancelText='Fechar'
      cancelButtonProps={{ type: 'text' }}
      okText={`Confirmar (${selectedQuantity})`}
    >
      <div className='flex w-full flex-1 flex-col gap-4 overflow-hidden pt-0'>
        <Input
          placeholder='Procure seu afiliado pelo nome ou e-mail'
          onChange={handleSearchChange}
          value={affiliateFilter}
          autoFocus
          autoComplete='off'
        />

        <Header handleUncheckAll={handleUncheckAll} selectedQuantity={selectedQuantity} />
        <List
          selectedAffiliates={selectedAffiliates}
          affiliates={filteredAffiliates}
          selectedQuantity={selectedQuantity}
        />
      </div>
    </Modal>
  );
};
